export default __webpack_public_path__ + "static/media/mugnut.dcbaa34c.svg";